export default __webpack_public_path__ + "static/media/two.9f87b2af.jpg";